import request from '@/router/axios'
import {VUE_APP_API_CONTEXT_PATH} from '@/utils/env'

const baseUrl = VUE_APP_API_CONTEXT_PATH

export function getStudyRecord (query) {
  return request({
    url: baseUrl + '/professional/tAppModel/getStudyRecord',
    method: 'get',
    params: query
  })
}
export function getMyJobList (query) {
  return request({
    url: baseUrl + '/professional/tAppModel/getMyJobList',
    method: 'get',
    params: query
  })
}
export function getCourseNoteList (query) {
  return request({
    url: baseUrl + '/professional/tAppModel/getCourseNotList',
    method: 'get',
    params: query
  })
}

export function listPersonal (query) {
  return request({
    url: baseUrl + '/system/tPerson/listAdmin',
    method: 'get',
    params: query
  })
}

export function userIntegralList (query) {
  return request({
    url: baseUrl + '/professional/appIntegral/userIntegralList',
    method: 'get',
    params: query
  })
}

export function exchangeRecordList (query) {
  return request({
    url: baseUrl + '/professional/appIntegral/exchangeRecordList',
    method: 'get',
    params: query
  })
}

export function getMyMedalList (query) {
  return request({
    url: baseUrl + '/professional/medalSetting/getMyMedalList',
    method: 'get',
    params: query
  })
}
export function getMyPersonCertificate (query) {
  return request({
    url: baseUrl + '/professional/tAppModel/getMyPersonCertificate',
    method: 'get',
    params: query
  })
}

export function updateUser(data) {
  return request({
    url: baseUrl + '/system/addressbook',
    method: 'put',
    data: data
  })
}
export function getInfoSetting() {
  return request({
    url: baseUrl + '/system/companySetting/getInfoSetting',
    method: 'get'
  })
}

// 获取公司
export function getCompanyList() {
  return request({
    url: baseUrl + '/system/tPerson/getCompanyList',
    method: 'get'
  })
}

// 切换企业用户
export function switchCompanyLogin(id) {
  return request({
    url: baseUrl + '/system/tCompany/changeAccount/'+id,
    method: 'put'
  })
}



// WEBPACK FOOTER //
// ./src/api/pc/personal.js